import React from "react";
import "./PartnerStatusLastUpdate.scss";
import { MdLocationOn, MdTimelapse } from "react-icons/md";

const PartnerStatusLastUpdate = ({ order }) => {
  return (
    <div id='PartnerStatusLastUpdate'>
      <h3>Last update</h3>
      <div className='lastUpdate'>
        <div className='title'>
          <h2>The truck is at the customs</h2>
          <div className='status'>
            <p>enroute</p>
          </div>
        </div>
        <div className='infoContainer'>
          <div className='leftSide'>
            <div className='item'>
              <div className='label'>
                <div className='icon'>
                  <MdLocationOn />
                </div>
                <p>Current location</p>
              </div>
              <div className='text'>Tbilisi,Georgia</div>
            </div>
            <div className='item'>
              <div className='label'>
                <div className='icon'>
                  <MdTimelapse />
                </div>
                <p>Estimate time of delivery</p>
              </div>
              <div className='text'>16/09/2025</div>
            </div>
          </div>
          <div className='time'>2 days ago</div>
        </div>
        <div className='comment'>
          <p>
            Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print,
            graphic or web designs.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerStatusLastUpdate;
